import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white/95 backdrop-blur-sm shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between py-5">
          <div className="flex items-center">
            <h1 className="text-2xl lg:text-3xl font-serif font-bold text-[#2C3E50]">
              {t('header.name')}
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("home")}
              className="text-[#2C3E50] hover:text-[#7C9885] transition-colors duration-200 font-medium"
            >
              {t('header.home')}
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="text-[#2C3E50] hover:text-[#7C9885] transition-colors duration-200 font-medium"
            >
              {t('header.services')}
            </button>
            <button
              onClick={() => scrollToSection("philosophy")}
              className="text-[#2C3E50] hover:text-[#7C9885] transition-colors duration-200 font-medium"
            >
              {t('header.philosophy')}
            </button>
            <Button
              onClick={() => scrollToSection("contact")}
              className="bg-[#7C9885] hover:bg-[#6A8573] text-white px-6 py-2 transition-colors duration-200"
            >
              {t('header.contact')}
            </Button>
          </nav>

          {/* Language Switcher & Mobile Menu Button */}
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            <button
              className="md:hidden text-[#2C3E50]"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden pb-6 space-y-4 bg-[#2C5F4D] -mx-6 px-6 mt-2 rounded-b-lg shadow-lg">
            <button
              onClick={() => scrollToSection("home")}
              className="block w-full text-left text-white hover:text-[#B8D5C8] transition-colors duration-200 font-medium py-3 pt-6"
            >
              {t('header.home')}
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="block w-full text-left text-white hover:text-[#B8D5C8] transition-colors duration-200 font-medium py-3"
            >
              {t('header.services')}
            </button>
            <button
              onClick={() => scrollToSection("philosophy")}
              className="block w-full text-left text-white hover:text-[#B8D5C8] transition-colors duration-200 font-medium py-3"
            >
              {t('header.philosophy')}
            </button>
            <Button
              onClick={() => scrollToSection("contact")}
              className="w-full bg-white hover:bg-[#F5F1E8] text-[#2C5F4D] transition-colors duration-200 font-semibold"
            >
              {t('header.contact')}
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;